import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-back-to-guardian',
  templateUrl: './back-to-guardian.component.html',
  styleUrls: ['./back-to-guardian.component.scss'],
})
export class BackToGuardianComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {}

  switchToGuardian() {
    firstValueFrom(this.authService.switchToGuardian()).then(() => {
      this.router.navigate(['/guardians']).then(() => {
        location.reload();
      });
    });
  }
}
